var ProductPage = {

	init: function(){

		this.bindUIActions();
	},

    bindUIActions: function() {

        $(document).on('click', '.product-item', function(e) {
            var self = $(this);
            var id=$(this).data("id");
            $('.product-item').removeClass('active');
            self.addClass('active');
            $('.product-description').removeClass('active');
            $('#product-'+id).addClass('active');
        });

	}//End bindUIActions

}
